import React from "react";
import { Outlet } from "react-router";
import Header from "../landingScreen/components/Header";
import { Footer } from "../homeScreen/components";
import "../landingScreen/components/Header.css";

function Layout() {
  return (
    <div>
      <Header />
      <div style={{ paddingTop: '56px' }}>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

export default Layout;
